export type ViewTranslate = (key: string, params?: Record<string, string | number>) => string

// Defaults are local to the view layer; option values and command values are never translated.
export const viewText: Record<string, string> = {
  'view.control.search': '搜索选项',
  'view.control.noResults': '无匹配结果',
  'view.control.clear': '清空',
  'view.common.cancel': '取消',
  'view.common.confirm': '确定',
  'view.common.none': '无',
  'view.common.leftAlign': '左对齐',
  'view.common.rightAlign': '右对齐',
  'view.common.center': '居中',
  'view.common.justify': '两端对齐',
  'view.common.distribute': '分散对齐',
  'view.common.preview': '预览',
  'view.common.color': '颜色',
  'view.common.spacing': '间距',
  'view.common.points': '磅',
  'view.paragraph.format': '段落格式',
  'view.paragraph.body': '正文',
  'view.paragraph.heading1': '一级标题',
  'view.paragraph.heading2': '二级标题',
  'view.paragraph.heading3': '三级标题',
  'view.paragraph.heading4': '四级标题',
  'view.paragraph.heading5': '五级标题',
  'view.paragraph.heading6': '六级标题',
  'view.paragraph.cut': '剪切',
  'view.paragraph.copy': '复制',
  'view.paragraph.paste': '粘贴',
  'view.paragraph.fontSettings': '字体...',
  'view.paragraph.advancedSettings': '段落高级设置',
  'view.paragraph.link': '超链接',
  'view.hyperlink.text': '显示文字',
  'view.hyperlink.address': '链接地址',
  'view.hyperlink.addressPlaceholder': '请输入完整地址（如 https://example.com）',
  'view.hyperlink.textRequired': '请输入显示文字',
  'view.hyperlink.addressRequired': '请输入链接地址',
  'view.hyperlink.addressInvalid': '链接地址必须使用 http、https、mailto、tel 或 ftp 协议',
  'view.hyperlink.unsupported': '超链接未插入，未能获取具体原因。请重新选择文字后重试，文档未修改。',
  'view.hyperlink.bookmarkSelection': '选区包含书签标记，当前编辑器暂不支持跨书签插入超链接。请调整选区避开书签边界；原文和书签均未修改。',
  'view.hyperlink.fieldSelection': '选区包含 Word 域标记（如目录或页码），暂不支持插入超链接。请选择域以外的普通文字，文档未修改。',
  'view.hyperlink.existingLink': '选区包含已有超链接，当前暂不支持嵌套或替换链接。请选择尚未添加链接的文字，文档未修改。',
  'view.hyperlink.crossContainer': '选区跨越不同文本容器（如段落或单元格）。请在同一段落内选择文字后重试，文档未修改。',
  'view.hyperlink.crossParagraph': '选区包含换行或段落结束标记。请选择同一段落内不含换行的文字，文档未修改。',
  'view.hyperlink.revisions': '选区包含尚未处理的修订。请先审阅并接受或拒绝相关修订，或选择不含修订的文字，文档未修改。',
  'view.hyperlink.tracking': '当前已开启修订模式，暂不支持插入超链接。请关闭修订模式后重试，文档未修改。',
  'view.hyperlink.readOnly': '文档处于只读模式，无法插入超链接。请切换到可编辑模式后重试，文档未修改。',
  'view.hyperlink.disabled': '编辑功能已被禁用，无法插入超链接。请启用编辑后重试，文档未修改。',
  'view.hyperlink.noSelection': '未找到光标位置或文字选区。请关闭弹窗，在正文中放置光标或选择文字后重试，文档未修改。',
  'view.hyperlink.invalidSelection': '文字选区已失效。请关闭弹窗并重新选择文字后重试，文档未修改。',
  'view.hyperlink.nonText': '选区包含图片、表格等非普通文本内容。请只选择普通文字，文档未修改。',
  'view.hyperlink.invalidText': '显示文字必须为非空的普通文本，且不能包含换行或隐藏控制标记。请修改显示文字后重试，文档未修改。',
  'view.paragraph.comment': '插入批注',
  'view.table.insert': '插入',
  'view.table.insertLeft': '在左侧插入',
  'view.table.insertRight': '在右侧插入',
  'view.table.insertAbove': '在上方插入',
  'view.table.insertBelow': '在下方插入',
  'view.table.columnUnit': '列',
  'view.table.rowUnit': '行',
  'view.table.insertCell': '单元格(E)...',
  'view.table.splitCell': '拆分单元格',
  'view.table.mergeCell': '合并单元格',
  'view.table.delete': '删除',
  'view.table.deleteRow': '删除行',
  'view.table.deleteColumn': '删除列',
  'view.table.deleteTable': '删除整个表格',
  'view.table.selectAll': '全选表格',
  'view.table.horizontalAlign': '水平对齐方式',
  'view.table.centerAlign': '居中对齐',
  'view.table.verticalAlign': '垂直对齐方式',
  'view.table.alignTop': '顶端对齐',
  'view.table.alignMiddle': '垂直居中',
  'view.table.alignBottom': '底端对齐',
  'view.table.background': '底纹颜色',
  'view.table.repeatHeader': '重复表头行',
  'view.table.properties': '表格属性',
  'view.table.select': '选择表格',
  'view.table.addColumn': '添加列',
  'view.table.addRow': '添加行',
  'view.font.title': '字体',
  'view.font.characterSpacing': '字符间距',
  'view.font.cjkFont': '中文字体',
  'view.font.style': '字形',
  'view.font.regular': '常规',
  'view.font.italic': '倾斜',
  'view.font.bold': '加粗',
  'view.font.boldItalic': '加粗倾斜',
  'view.font.size': '字号',
  'view.font.effects': '效果',
  'view.font.strikethrough': '删除线',
  'view.font.underline': '下划线',
  'view.font.superscript': '上标',
  'view.font.subscript': '下标',
  'view.font.doubleStrikethrough': '双删除线',
  'view.font.hidden': '隐藏',
  'view.font.previewText': '字体预览文本 ABCabc 123',
  'view.font.scale': '缩放',
  'view.font.standard': '标准',
  'view.font.expanded': '加宽',
  'view.font.condensed': '紧缩',
  'view.font.position': '位置',
  'view.font.raised': '提升',
  'view.font.lowered': '降低',
  'view.font.spacingPreview': '字符间距预览 ABCabc 123',
  'view.font.unsupported': '间距与位置功能将在后续版本支持',
  'view.paragraphDialog.title': '段落',
  'view.paragraphDialog.indentSpacing': '缩进和间距',
  'view.paragraphDialog.linePageBreak': '换行和分页',
  'view.paragraphDialog.cjkLayout': '中文版式',
  'view.paragraphDialog.general': '常规',
  'view.paragraphDialog.alignment': '对齐方式',
  'view.paragraphDialog.outline': '大纲级别',
  'view.paragraphDialog.bodyText': '正文文本',
  'view.paragraphDialog.level1': '1 级',
  'view.paragraphDialog.level2': '2 级',
  'view.paragraphDialog.level3': '3 级',
  'view.paragraphDialog.level4': '4 级',
  'view.paragraphDialog.level5': '5 级',
  'view.paragraphDialog.level6': '6 级',
  'view.paragraphDialog.indent': '缩进',
  'view.paragraphDialog.beforeText': '文本之前',
  'view.paragraphDialog.afterText': '文本之后',
  'view.paragraphDialog.special': '特殊格式',
  'view.paragraphDialog.firstLine': '首行缩进',
  'view.paragraphDialog.hanging': '悬挂缩进',
  'view.paragraphDialog.measure': '度量值',
  'view.paragraphDialog.cm': '厘米',
  'view.paragraphDialog.adjustRightIndent': '如果定义了文档网格，则自动调整右缩进',
  'view.paragraphDialog.before': '段前',
  'view.paragraphDialog.after': '段后',
  'view.paragraphDialog.lineSpacing': '行距',
  'view.paragraphDialog.single': '单倍行距',
  'view.paragraphDialog.oneHalf': '1.5 倍行距',
  'view.paragraphDialog.double': '双倍行距',
  'view.paragraphDialog.atLeast': '最小值',
  'view.paragraphDialog.exact': '固定值',
  'view.paragraphDialog.multiple': '多倍行距',
  'view.paragraphDialog.setting': '设置值',
  'view.paragraphDialog.times': '倍',
  'view.paragraphDialog.alignGrid': '如果定义了文档网格，则与网格对齐',
  'view.paragraphDialog.previewText': '段落预览文本',
  'view.paragraphDialog.pagination': '分页',
  'view.paragraphDialog.widow': '孤行控制',
  'view.paragraphDialog.keepNext': '与下段同页',
  'view.paragraphDialog.breakBefore': '段前分页',
  'view.paragraphDialog.lineBreak': '换行',
  'view.paragraphDialog.noLineNumber': '取消行号',
  'view.paragraphDialog.noHyphen': '取消断字',
  'view.paragraphDialog.unsupported': '该功能将在后续版本支持',
  'view.paragraphDialog.cjkWrap': '按中文习惯换行',
  'view.paragraphDialog.punctuationOverflow': '允许标点溢出边界',
  'view.paragraphDialog.wordBreak': '允许西文在单词中间换行',
  'view.paragraphDialog.compressPunctuation': '允许行首标点压缩',
  'view.paragraphDialog.cjkWesternSpacing': '自动调整中文与西文的间距',
  'view.paragraphDialog.cjkNumberSpacing': '自动调整中文与数字的间距',
  'view.paragraphDialog.textAlignment': '文字对齐方式',
  'view.paragraphDialog.align': '对齐',
  'view.paragraphDialog.auto': '自动',
  'view.paragraphDialog.baseline': '基线对齐',
  'view.tableDialog.categories': '属性类别',
  'view.tableDialog.table': '表格',
  'view.tableDialog.cell': '单元格',
  'view.tableDialog.presetHint': '预设替换整个表格的边框组合，未选中的边将清除。',
  'view.tableDialog.border': '边框',
  'view.tableDialog.preset': '预设',
  'view.tableDialog.unchanged': '保持原样',
  'view.tableDialog.allBorders': '全部边框',
  'view.tableDialog.outsideBorders': '外侧边框',
  'view.tableDialog.noBorders': '无边框',
  'view.tableDialog.insideBorders': '内部边框',
  'view.tableDialog.insideHorizontal': '内部横线',
  'view.tableDialog.insideVertical': '内部竖线',
  'view.tableDialog.topBorder': '上边框',
  'view.tableDialog.bottomBorder': '下边框',
  'view.tableDialog.leftBorder': '左边框',
  'view.tableDialog.rightBorder': '右边框',
  'view.tableDialog.borderPresets': '边框预设',
  'view.tableDialog.all': '全部',
  'view.tableDialog.outside': '外侧',
  'view.tableDialog.inside': '内部',
  'view.tableDialog.colorFormatTitle': '请输入 #RRGGBB 格式的颜色',
  'view.tableDialog.colorFormatClearTitle': '请输入 #RRGGBB 格式的颜色，留空清除',
  'view.tableDialog.borderColor': '边框颜色',
  'view.tableDialog.cellColor': '单元格底色',
  'view.tableDialog.chooseColor': '选择{label}（当前{state}）',
  'view.tableDialog.innerWidth': '内框宽度',
  'view.tableDialog.outerWidth': '外框宽度',
  'view.tableDialog.innerWidthAria': '内框宽度（像素）',
  'view.tableDialog.outerWidthAria': '外框宽度（像素）',
  'view.tableDialog.colorHelp': '颜色格式：#RRGGBB；留空保持原样。',
  'view.tableDialog.borderPreview': '边框示意',
  'view.tableDialog.presetPreview': '边框组合示意；虚线仅标示表格范围。未填写的颜色、宽度保持原样。',
  'view.tableDialog.unchangedPreview': '未选择预设，边框组合保持原样；示意不代表混合样式。',
  'view.tableDialog.cellHint': '以下设置仅应用于当前单元格（右键所在格）。',
  'view.tableDialog.fill': '底色',
  'view.tableDialog.noFill': '无底色',
  'view.tableDialog.invalidColor': '颜色格式无效',
  'view.tableDialog.clearFill': '清除底色',
  'view.tableDialog.fillHelp': '颜色格式：#RRGGBB；留空表示无底色。',
  'view.tableDialog.verticalAlign': '垂直对齐',
  'view.tableDialog.alignCenter': '居中对齐',
  'view.pageNumber.header': '页眉',
  'view.pageNumber.footer': '页脚',
  'view.pageNumber.insert': '插入页码',
  'view.pageNumber.style': '样式:',
  'view.pageNumber.position': '位置:',
  'view.pageNumber.left': '左侧',
  'view.pageNumber.center': '居中',
  'view.pageNumber.right': '右侧',
  'view.pageNumber.stylePage': '第1页',
  'view.pageNumber.styleTotal': '第1页共x页',
  'view.pageNumber.styleFirst': '第一页',
  'view.pageNumber.styleFirstTotal': '第一页共X页',
  'view.fontFamily.SimSun': '宋体',
  'view.fontFamily.SimHei': '黑体',
  'view.fontFamily.KaiTi': '楷体',
  'view.fontFamily.FangSong': '仿宋',
  'view.fontFamily.MicrosoftYaHei': '微软雅黑',
  'view.fontFamily.DengXian': '等线',
  'view.fontFamily.STSong': '华文宋体',
  'view.fontFamily.STHeiti': '华文黑体',
  'view.fontFamily.STKaiti': '华文楷体',
  'view.fontFamily.STFangsong': '华文仿宋',
  'view.fontFamily.STZhongsong': '华文中宋',
  'view.fontFamily.STXihei': '华文细黑',
  'view.fontFamily.STXingkai': '华文行楷',
  'view.fontFamily.STLiti': '华文隶书',
  'view.fontFamily.STXinwei': '华文新魏',
  'view.fontFamily.STCaiyun': '华文彩云',
  'view.fontSize.chuhao': '初号',
  'view.fontSize.xiaochu': '小初',
  'view.fontSize.yihao': '一号',
  'view.fontSize.xiaoyi': '小一',
  'view.fontSize.erhao': '二号',
  'view.fontSize.xiaoer': '小二',
  'view.fontSize.sanhao': '三号',
  'view.fontSize.xiaosan': '小三',
  'view.fontSize.sihao': '四号',
  'view.fontSize.xiaosi': '小四',
  'view.fontSize.wuhao': '五号',
  'view.fontSize.xiaowu': '小五',
  'view.fontSize.liuhao': '六号',
  'view.fontSize.xiaoliu': '小六',
  'view.fontSize.qihao': '七号',
  'view.fontSize.bahao': '八号'
}

export function viewTranslate(translate: ViewTranslate | undefined, key: string, params?: Record<string, string | number>): string {
  const fallback = viewText[key] ?? key
  const result = translate?.(key, params)
  const text = !result || result === key ? fallback : result
  return text.replace(/\{(\w+)}/g, (_, name: string) => String(params?.[name] ?? `{${name}}`))
}

// Translate template text nodes and display-only attributes, leaving form values intact.
const textKeys = new WeakMap<Text, string>()

export function translatePanel(root: HTMLElement, translate: ViewTranslate | undefined, prefix: string): void {
  const entries = Object.entries(viewText)
  const preferred = entries.filter(([key]) => key.startsWith(prefix) || key.startsWith('view.common.'))
  const byText = new Map([...entries, ...preferred].map(([key, value]) => [value, key]))
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
  while (walker.nextNode()) {
    const node = walker.currentNode as Text
    const raw = node.textContent ?? ''
    const text = raw.trim()
    const key = textKeys.get(node) ?? byText.get(text)
    if (key) {
      textKeys.set(node, key)
      node.textContent = raw.replace(text, () => viewTranslate(translate, key))
    }
  }
  for (const el of [root, ...Array.from(root.querySelectorAll<HTMLElement>('*'))]) {
    const keyedText = el.dataset.i18nKey
    if (keyedText) el.textContent = viewTranslate(translate, keyedText)
    for (const attr of ['title', 'aria-label', 'placeholder']) {
      const marker = `i18n${attr === 'aria-label' ? 'AriaLabel' : attr[0].toUpperCase() + attr.slice(1)}`
      const raw = el.getAttribute(attr)
      const key = el.dataset[marker] ?? (raw && byText.get(raw))
      if (key) {
        el.dataset[marker] = key
        el.setAttribute(attr, viewTranslate(translate, key))
      }
    }
  }
}
